var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"text-center p-5"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'spinner'],"spin":"","size":"2x"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }